var _style, _polygon, _polygon2, _polygon3, _path, _polygon4, _polygon5, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDdexsvg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 538 232.6",
    style: {
      enableBackground: "new 0 0 538 232.6"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:url(#SVGID_1_);}\n\t.st1{fill:url(#SVGID_2_);}\n\t.st2{fill:url(#SVGID_3_);}\n\t.st3{fill:url(#SVGID_4_);}\n\t.st4{fill:url(#SVGID_5_);}\n\t.st5{fill:#3467B1;}\n")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 74.8532,
    y1: 65.561,
    x2: 74.8532,
    y2: 167.9371
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#184799"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#28388A"
    }
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "56.5,65.2 93.2,116.6 56.5,167.7  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 92.9892,
    y1: 64.8405,
    x2: 92.9892,
    y2: 116.7222
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#44C1C3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#007CB6"
    }
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "129.4,65 93.2,116.6 56.5,65.2  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 56.5322,
    y1: 154.9864,
    x2: 129.5198,
    y2: 154.9864
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#0671B9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#00A7E0"
    }
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "56.5,167.7 111.5,142.3 129.5,167.5  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: 118.9256,
    y1: 72.4268,
    x2: 137.2,
    y2: 141.7909
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#68CBE2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4914,
    style: {
      stopColor: "#0CBFF1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6075,
    style: {
      stopColor: "#1BB8EC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.814,
    style: {
      stopColor: "#2CA6DE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#3893D0"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M129.4,65c2.1,2.4,38.4,51.3,38.4,51.3l-56.4,26l-18.3-25.7L129.4,65z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_",
    gradientUnits: "userSpaceOnUse",
    x1: 111.4975,
    y1: 141.9109,
    x2: 167.8611,
    y2: 141.9109
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#3EC3DA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#64CADD"
    }
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "167.9,116.3 129.5,167.5 111.5,142.3  "
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "93.2,116.6 56.5,167.7 111.5,142.3  "
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M228.1,146.3h-34.8c-1,0-1.8-0.8-1.8-1.8V88.3c0-1,0.8-1.8,1.8-1.8h35.4c16.3,0,29.6,13.1,29.9,29.4 C258.8,132.7,244.8,146.3,228.1,146.3z M202.9,134.9h25.8c10.2,0,18.4-8.3,18.4-18.4S238.8,98,228.7,98h-25.8V134.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M302.2,146.3h-34.8c-1,0-1.8-0.8-1.8-1.8V88.3c0-1,0.8-1.8,1.8-1.8h35.4c16.3,0,29.6,13.1,29.9,29.4 C333,132.7,318.9,146.3,302.2,146.3z M277,134.9h25.8c10.2,0,18.4-8.3,18.4-18.4S313,98,302.8,98H277V134.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M405.3,146.1h-34.9c-16.7,0-30.7-13.7-30.5-30.4c0.3-16.2,13.6-29.4,29.9-29.4h35.5c1,0,1.8,0.8,1.8,1.8V96 c0,1-0.8,1.8-1.8,1.8l-35.1,0c-10,0-18.5,7.8-18.9,17.7c-0.4,10.5,8,19.2,18.4,19.2h35.5c1,0,1.8,0.8,1.8,1.8v7.9 C407,145.3,406.2,146.1,405.3,146.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M405.8,122.2h-34.3c-3.2,0-5.7-2.6-5.7-5.7v0c0-3.2,2.6-5.7,5.7-5.7h34.3c1,0,1.8,0.8,1.8,1.8v7.9 C407.6,121.4,406.8,122.2,405.8,122.2z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M456.5,116.5L481,89.5c1-1.1,0.2-2.9-1.3-2.9H469c-0.5,0-1,0.2-1.3,0.6L448.8,108l-18.9-20.8c-0.3-0.4-0.8-0.6-1.3-0.6 H418c-1.5,0-2.3,1.8-1.3,2.9l24.4,26.9l-24.4,26.9c-1,1.1-0.2,2.9,1.3,2.9h10.7c0.5,0,1-0.2,1.3-0.6l18.9-20.8l18.9,20.8 c0.3,0.4,0.8,0.6,1.3,0.6h10.7c1.5,0,2.3-1.8,1.3-2.9L456.5,116.5z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDdexsvg);
export default __webpack_public_path__ + "static/media/ddexsvg.a94b81cae1c0b3d2d0684a4b5826c717.svg";
export { ForwardRef as ReactComponent };